import React from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Row,
  Col
} from 'reactstrap';
import ProgressBox from '@src/components/ProgressBox/ProgressBox';
import 'react-dates/initialize';
import { SingleDatePicker } from 'react-dates';
import 'react-dates/lib/css/_datepicker.css';
import axiosInstance from '@src/axios-instance';
import moment from 'moment';
import LabelInput from '@components/LabelInput/LabelInput';
import EOITypes from '@components/EvidenceOfInsurance/Types/Types';

class EvidenceOfInsuranceModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      issueDate: props.issueDate !== undefined ? props.issueDate : moment(),
      ref_number: '',
      type: 'refinance',
      focused: false,
      error: false
    };
  }

  submitHandler = e => {
    e.preventDefault();

    if (this.state.issueDate === null) {
      this.setState({ error: 'This field is required.' });
    }

    this.props.loader(true);

    if (this.props.edit === undefined) {
      axiosInstance()
        .post('/evidence-of-insurances.json', {
          issue_date: this.state.issueDate.unix(),
          ref_number: this.state.ref_number,
          type: this.state.type,
          entity_id: this.props.entity.id,
          evidence_of_insurance_id: this.props.eoiId
        })
        .then(response => {
          this.props.history.push(`/eois/${response.data.id}`);
        });
    } else {
      this.props.saveEntity({ issue_date: this.state.issueDate.unix() }, () => {
        this.props.loader(false);
        this.props.toggle();
      });
    }

    return false;
  };

  render = () => {
    return (
      <Modal
        isOpen={this.props.isActive}
        toggle={this.props.toggle}
        className={this.props.className}
      >
        <form
          ref={c => {
            this.form = c;
          }}
          onSubmit={this.submitHandler.bind(this)}
        >
          <ModalHeader toggle={this.props.toggle}>
            {this.props.edit !== undefined
              ? 'Edit association Information'
              : 'Create New EOI'}
          </ModalHeader>
          <div className={'position-relative'}>
            {this.props.loading && <ProgressBox text={'Submiting ...'} />}
            <ModalBody className={'p-4'}>
              <Row>
                <Col xs={12}>
                  <div className={'form-group'}>
                    <label className={'font-weight-bold'}>Issue Date *</label>
                    <div className={this.state.error ? 'is-invalid' : ''}>
                      <SingleDatePicker
                        date={this.state.issueDate} // momentPropTypes.momentObj or null
                        onDateChange={issueDate => this.setState({ issueDate })} // PropTypes.func.isRequired
                        focused={this.state.focused} // PropTypes.bool
                        block={true}
                        isOutsideRange={() => false}
                        onFocusChange={({ focused }) =>
                          this.setState({ focused })
                        } // PropTypes.func.isRequired
                        id="your_unique_id" // PropTypes.string.isRequired,
                      />
                    </div>
                    {this.state.error && (
                      <span className={'error'}>{this.state.error}</span>
                    )}
                  </div>
                </Col>
                <Col xs={12}>
                  <LabelInput
                    name={'Reference Number'}
                    type={'text'}
                    value={this.state.ref_number}
                    onChange={event =>
                      this.setState({
                        ref_number: event.target.value
                      })
                    }
                  />
                </Col>
                <Col xs={12}>
                  <div className={'form-group'}>
                    <label className={'font-weight-bold'}>EOI Type</label>
                    <select
                      className={'form-control'}
                      value={this.state.type.value}
                      onChange={event =>
                        this.setState({
                          type: event.target.value
                        })
                      }
                    >
                      {EOITypes.map(item => {
                        return (
                          <option key={item.key} value={item.key}>
                            {item.label}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                </Col>
              </Row>
            </ModalBody>
            <ModalFooter className={'py-4'}>
              <Button color="primary" className={'btn px-3'} type={'submit'}>
                {this.props.edit !== undefined ? 'Save' : 'Create'}
              </Button>
            </ModalFooter>
          </div>
        </form>
      </Modal>
    );
  };
}
export default EvidenceOfInsuranceModal;
